export default __webpack_public_path__ + "static/media/bayadLogo.2e2c188f.png";